export const TIME_API_URL = `worldtimeapi.org/api/timezone/UTC`;
